'use strict';

import controller from './tour-help.controller';

const Tourhelp = {
    bindings: {
        tour: '<',
        tourEnd: '<',
        tourLabel: '<'
    },
    template: ``,
    controller
};

export default Tourhelp;


// WEBPACK FOOTER //
// ./src/app/common/core/util/help/tour-help/tour-help.component.js